import useTracking from './use-tracking';

export { default as usePageTracking } from './use-page-tracking';
export { executeWhenCookiesAccepted, isDevEnv } from './lib/cookie-banner';

export default useTracking;
